import { RootSelector, getStore } from '../../reducers';
import { ALL_EXTENSIONS_NAME, ExtensionShape, sortExtensions } from './model';
import { createSelector } from '@reduxjs/toolkit';
import { Extension } from '../../api';
import { ALL_EXTENSIONS_ID } from './model';
import { DataNode } from 'rc-tree/lib/interface';

export const getExtension: RootSelector<ExtensionShape> = createSelector(
  getStore,
  (state) => state.extension,
);

export const getExtensions: RootSelector<Extension[]> = createSelector(
  getExtension,
  (extension) => extension.extensions,
);

export const getExtensionsById: RootSelector<Partial<Record<Extension['id'], Extension>>> =
  createSelector(getExtensions, (extensions) => {
    const result: Partial<Record<Extension['id'], Extension>> = {};
    extensions.forEach((extension) => {
      result[extension.id] = extension;
    });
    return result;
  });

export const getSelectedIds: RootSelector<Extension['id'][]> = createSelector(
  getExtension,
  (extension) => extension.selectedIds,
);

export const getExpandedKeys: RootSelector<Extension['id'][]> = createSelector(
  [getExtension],
  (extension) => extension.expandedKeys,
);

export const getLoading: RootSelector<boolean> = createSelector(
  getExtension,
  (extension) => extension.loading,
);

export const getTreeData: RootSelector<DataNode[]> = createSelector(
  [getExtensions],
  (extensions) => {
    return [
      {
        key: ALL_EXTENSIONS_ID,
        title: ALL_EXTENSIONS_NAME,
        children: [...extensions].sort(sortExtensions).map((extension) => ({
          key: extension.id,
          title: extension.name,
        })),
      },
    ];
  },
);

export const getExtensionsCollapsed = createSelector(
  [getSelectedIds, getExtensionsById],
  (selectedIds, extensionsById) => {
    if (selectedIds.length === 1 && selectedIds[0] === ALL_EXTENSIONS_ID) {
      return ALL_EXTENSIONS_NAME;
    }

    const titles = selectedIds
      .map((id) => extensionsById[id])
      .filter((extension): extension is NonNullable<typeof extension> => Boolean(extension))
      .sort(sortExtensions)
      .map(({ name }) => name);

    const title = titles[0] ?? '';
    const result = `${title}${titles.length > 1 ? ` +${titles.length - 1}` : ''}`;
    return result;
  },
);
